import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import footerBg from '../../assets/footerimages/Supreme-Court.png';
import logoImage from '../../assets/images/S.R.S Kannan.svg';

const Footer: React.FC = () => {
  const [email, setEmail] = useState('');

  const handleEmailSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Newsletter subscription:', email);
    alert('Thank you for subscribing to our newsletter!');
    setEmail('');
  };



  return (
    <>
      <footer className="footer" style={{ backgroundImage: `url(${footerBg})` }}>
        <div className="footer-overlay"></div>
        <div className="container">
          <div className="footer-content">
            {/* Right Column - Contact Info */}
            <div className="footer-section contact-section">
              <div className="navbar-logo">
                <img src={logoImage} alt="Advocate Kannan" className="logo-icon" style={{ width: '200px', height: 'auto' }} />
              </div>

              <p className="contact-item" style={{ marginBottom: "2rem", marginTop: "-1rem" }}>
                Welcome to S.R.S. Kannan, where our team of experienced lawyers are dedicated to providing you with top-notch legal services.
              </p>

              <div className="footer-social-links">
                <a
                  href="https://facebook.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Facebook"
                  className="footer-social-icon"
                >
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                  </svg>
                </a>
                <a
                  href="https://twitter.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Twitter"
                  className="footer-social-icon"
                >
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z" />
                  </svg>
                </a>
                <a
                  href="https://instagram.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Instagram"
                  className="footer-social-icon"
                >
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                  </svg>
                </a>
                <a
                  href="https://youtube.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="YouTube"
                  className="footer-social-icon"
                >
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
                  </svg>
                </a>
              </div>
            </div>
            {/* Services Column */}
            <div className="footer-section services-section">
              <h3 className="footer-heading">Services</h3>
              <div className="Quick-links-container">
                <ul className="Quick-links-column">
                  <li>
                    <Link to="/services/civil-law">Civil Law</Link>
                  </li>
                  <li>
                    <Link to="/services/property-law">Property Law</Link>
                  </li>
                  <li>
                    <Link to="/services/criminal-law">Criminal Law</Link>
                  </li>
                  <li>
                    <Link to="/services/banking-law">Banking Law</Link>
                  </li>
                  <li>
                    <Link to="/services/consumer-law">Consumer Law</Link>
                  </li>
                </ul>
                <ul className="Quick-links-column">
                  <li>
                    <Link to="/services/insurance-law">Insurance Law</Link>
                  </li>
                  <li>
                    <Link to="/services/arbitration-law">Arbitration Law</Link>
                  </li>
                  <li>
                    <Link to="/services/chit-fund">Chit Fund Cases</Link>
                  </li>
                  <li>
                    <Link to="/services/debt-recovery-tribunal">Debt Recovery Tribunal</Link>
                  </li>
                  <li>
                    <Link to="/services/electricity-law">Electricity Law</Link>
                  </li>
                </ul>
              </div>
            </div>
            {/* Quick Links Column */}
            <div className="footer-section quick-links-section">
              <h3 className="footer-heading">Quick Links</h3>
              <ul className="Quick-links-column">
                <li>
                  <Link to="/">Home</Link>
                </li>
                <li>
                  <Link to="/about">About Us</Link>
                </li>
                <li>
                  <Link to="/blog">Resources</Link>
                </li>
                <li>
                  <Link to="/disclaimer">Disclaimer</Link>
                </li>
                <li>
                  <Link to="/privacy-policy">Privacy Policy</Link>
                </li>
                <li>
                  <Link to="/contact">Contact Us</Link>
                </li>
              </ul>
            </div>

            {/* Left Column - Newsletter */}


            <div className="footer-section Address-section">
              <h3 className="footer-heading">For Consulting</h3>
              <div className="footer-contact-info">
                <p className="contact-item">
                  <a href="https://maps.app.goo.gl/hUJCH5F27bfJSo9G9" target="_blank" rel="noopener noreferrer" className="footer-contact-link">
                    S-2, 9/91 Sri Vari Complex, Grey Town, Sri Kant EXTN, Coimbatore -641018
                  </a>
                </p>

                <p className="contact-item" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0, color: '#fca311' }}>
                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                  </svg>
                  <a href="tel:9489105357" className="footer-contact-link">(+91) 94891 05357</a>
                </p>
                <p className="contact-item" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0, color: '#fca311' }}>
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                    <polyline points="22,6 12,13 2,6"></polyline>
                  </svg>
                  <a href="mailto:skannansrs@gmail.com" className="footer-contact-link">skannansrs@gmail.com</a>
                </p>
              </div>

              <div className="newsletter-section">
                <form className="newsletter-form" onSubmit={handleEmailSubmit}>
                  <input
                    type="email"
                    placeholder="Enter Your Email Address"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="newsletter-input"
                    required
                  />
                  <button type="submit" className="newsletter-btn">
                    Subscribe
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      className="btn-icon"
                    >
                      <path d="M5 12h14M12 5l7 7-7 7" />
                    </svg>
                  </button>
                </form>
              </div>
            </div>


          </div>

          {/* Bottom Bar */}
          <div className="footer-bottom">
            <p className="copyright">Copyright © 2026 Law Firm, All Rights Reserved. Concept by <a href="https://jeevantech.in/services/web-development-services/ ">Jeevan Tech</a></p>
          </div>
        </div>
      </footer>

    </>
  );
};

export default Footer;
